export const PUBLIC_PATHS = [
  '/login',
  '/politica-privacidad',
  '/aviso-legal',
  '/politica-cookies',
];

export function isPublicPath(pathname: string): boolean {
  return PUBLIC_PATHS.includes(pathname);
}
